export default {
  title: 'People Settings',

  labels: {
    gender: 'gender mandatory'
  }
}
